import { render, staticRenderFns } from "./ModificaOreDiario.vue?vue&type=template&id=2aadcf95&scoped=true&"
import script from "./ModificaOreDiario.vue?vue&type=script&lang=js&"
export * from "./ModificaOreDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aadcf95",
  null
  
)

export default component.exports